import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { Web3AuthProvider } from './contexts/Web3Auth';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './locales/configuration/i18n';

const queryClient = new QueryClient();

ReactDOM.render(
  <HelmetProvider>
    <SidebarProvider>
      <Web3AuthProvider chain={'goerli'} web3AuthNetwork={'testnet'}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </Web3AuthProvider>
    </SidebarProvider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
